import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import Img from "@insite/mobius/Img";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";
import { connect } from "react-redux";
import Link from "@insite/mobius/Link";
import { getLink, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";

const mapStateToProps = (state: ApplicationState) => ({
    state
});
interface IndustryItem {
    image: string;
    label: string;
    description: string;
    buttonLink: LinkFieldValue;
}

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;
interface PropsComponent extends Props {
    fields: {
        industries: IndustryItem[];
    };
}

const styles: {
    iconGrid: InjectableCss;
    iconItem: InjectableCss;
    iconImage: InjectableCss;
    iconLabel: InjectableCss;
    iconDescription?: InjectableCss;
} = {
    iconGrid: {
        css: css`
            gap: 20px !important;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            max-width: 1000px;
            background: transparent;
            padding: 0;
            >div{
            justify-content: center;
            }
        `,
    },
    iconItem: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100px;
            text-align: center;
            flex-grow: 1 !important;
            max-width: none !important; 
        `,
    },
    iconImage: {
        css: css`
            width: 100%;
            height: auto;
            margin-bottom: 2px;
            object-fit: contain;
            border-radius: 5px;
        `,
    },
    iconLabel: {
        css: css`
            font-size: 1.5rem;
            line-height: normal;
            color: #005bac;
            text-transform: uppercase;
            font-weight: 600;
            margin-top: 10px;
            margin-bottom: 10px;
            font-family: Barlow-Regular;
        `,
    },
    iconDescription:{
        css:css`
        font-size: 0.9rem;
        text-align: center;
        font-family: SourceSans3-Regular;
        `
    }
};


export const IndustriesServedGridTest: React.FC<PropsComponent> = ({ fields, state }) => {
   
    let industries = (fields.industries || []).map(item =>
        {
            let links;
            if((item as any).fields.buttonLink){
                links = getLink(state, (item as any).fields.buttonLink);
            }
            return (item as any).fields ? {...(item as any).fields,links} : {...item,links}
        }
    );
    return (
        <GridContainer {...styles.iconGrid}>
            {industries.map((industry, idx) =>{
                return (
                <GridItem width={[12,6,4,3,2]} {...styles.iconItem} key={idx}>
                    <Link
                        href={industry?.links?.url || ""}
                        style={{ cursor: industry?.links?.url ? "pointer" : "default" }}
                    >
                        <Img
                            src={industry.image}
                            alt={industry.label}
                            {...styles.iconImage}
                        />
                        <Typography {...styles.iconLabel}>{industry.label}</Typography>
                    </Link>
                    <Typography {...styles.iconDescription}>{industry.description}</Typography>
                </GridItem>
            )})}
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component:  connect(mapStateToProps)(IndustriesServedGridTest),
    definition: {
        group: "Basic",
        icon: "image",
        displayName: "About us Sun-Source Advantage Grid",
        fieldDefinitions: [
            {
                name: "industries",
                displayName: "Industries",
                editorTemplate: "ListField",
                fieldType: "Contextual",
              //  getDisplay: (item) => ((item as unknown) as IndustryItem).label || "Industry",
                getDisplay: ({ fields: { label } }) => label || "Service",
                fieldDefinitions: [ 
                    {
                        name: "image",
                        displayName: "Image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "label",
                        displayName: "Label",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "description",
                        displayName: "Description",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "buttonLink",
                        displayName: "Button Link",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                    },
                ],
                defaultValue: [],
            },
],
    },
};

export default widgetModule;